import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux';
import { cancel, deleteComponentConfirmed } from '../state/actions/delete';
import { getContext } from '../state/selectors/context';
import { isDialogOpen, isInProgress } from '../state/selectors/modal';
import type { State } from '../state/types';
import Delete from './view';

const mapStateToProps = (state: State) => ({
	context: getContext(state),
	isDialogOpen: isDialogOpen(state),
	isInProgress: isInProgress(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onCancel: () => {
		dispatch(cancel());
	},
	onConfirm: (moveIssuesTo?: string) => {
		dispatch(deleteComponentConfirmed(moveIssuesTo));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(Delete);
